import React from 'react'
 
export default function WeddingGallery() {
  return (
    <>
      <section className="wedding-gallery-area">
        <img src="/image/wedding-gallery-banner.webp" alt="banner" className="img-responsive wow animate__animated animate__fadeInUp" data-wow-duration="1.1s" />
        <div className="wedding-gallery-wrapper">
          <img src="/image/wedding-gallery-1.webp" alt="banner" className="img-responsive" />
          <div className="container">
            <div className="row justify-content-end">
              <div className="col-lg-4 col-md-4">
                <div className="wedding-gallery-images">
                  <img className="img-responsive" src='/image/wedding-gallery-2.webp' alt='Wedding Gallery' />
                  <img className="img-responsive wow animate__animated animate__fadeInRight" data-wow-delay="0.2s" data-wow-duration="1.2s" src='/image/wedding-gallery-3.webp' alt='Wedding Gallery' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
